
  export default {
    name: 'ThemeStoresMobileAndroidPrivacy'
  }
